module.exports = __webpack_public_path__ + "img/Z86Q_15.a7e11ffa.jpg";